import { graphql, useStaticQuery } from "gatsby";

export const useNavigationData = () => {
  const data = useStaticQuery(graphql`
    query {
      allSanitySettings {
        nodes {
          footerCopy {
            en_title
            fr_title
          }
          menu {
            links {
              ... on SanityLinkInternal {
                id
                title
                reference {
                  slug {
                    current
                  }
                }
                i18n_refs {
                  title
                  reference {
                    slug {
                      current
                    }
                  }
                }
              }
              ... on SanityLinkGroup {
                id
                i18n_lang
                title
                mobile_only
                i18n_refs {
                  links {
                    ... on SanityLinkExternal {
                      id
                      url
                      title
                      i18n_lang
                    }
                    ... on SanityLinkInternal {
                      id
                      title
                      i18n_lang
                      reference {
                        slug {
                          current
                        }
                      }
                    }
                  }
                  i18n_lang
                  title
                }
                links {
                  ... on SanityLinkInternal {
                    id
                    title
                    reference {
                      slug {
                        current
                      }
                    }
                  }
                  ... on SanityLinkExternal {
                    id
                    title
                    url
                  }
                }
              }
            }
          }

          footer {
            links {
              ... on SanityLinkInternal {
                title
                reference {
                  title
                  slug {
                    current
                  }
                }
                i18n_refs {
                  title
                  reference {
                    slug {
                      current
                    }
                  }
                }
                _type
              }
              ... on SanityLinkExternal {
                title
                _rawContent(resolveReferences: { maxDepth: 10 })
                url
                _type
                i18n_refs {
                  title
                  url
                }
              }
            }
          }
        }
      }
    }
  `);

  return data.allSanitySettings.nodes[0];
};
